"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScreenWidth = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
/**
 * Custom hook that tracks the screen width and invokes a resize function if provided.
 *
 * @param {resizerFn} resizeFn - The resize function to invoke when the screen width changes. Defaults to `() => {}` -.
 * @return {number} The current screen width.
 */
var useScreenWidth = function (options) {
    if (options === void 0) { options = {}; }
    var resizeFn = options.resizeFn;
    var _a = (0, react_1.useState)(document.documentElement.clientWidth), screenWidth = _a[0], setScreenWidth = _a[1];
    var handleResize = (0, lodash_1.debounce)(function () {
        setScreenWidth(document.documentElement.clientWidth);
        resizeFn === null || resizeFn === void 0 ? void 0 : resizeFn();
    }, 500);
    (0, react_1.useEffect)(function () {
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);
    return screenWidth;
};
exports.useScreenWidth = useScreenWidth;
